import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import useNotify from 'hooks/useNotify';
import useIsPropertyGuidebookEnabled from 'hooks/guidebook/useIsPropertyGuidebookEnabled';
import BookIconSvg from 'assets/images/icons/book.svg?react';
import Tooltip from 'components/tooltip/Tooltip';
import useGetPropertyGuidebookAccessUrl from 'hooks/guidebook/useGetPropertyGuidebookAccessUrl';
import { IconButton } from './CommonHeader.styles';

const GuidebookHeaderButton = ({ propertyUid }: { propertyUid?: string }) => {
  const isGuidebookEnabled = useIsPropertyGuidebookEnabled();
  const [guidebookButtonDisabled, setGuidebookButtonDisabled] =
    useState<boolean>(false);
  const { getPropertyGuidebookURL, isFetching: isFetchingGuidebook } =
    useGetPropertyGuidebookAccessUrl();
  const { notifyError } = useNotify();
  const { t } = useTranslation();

  useEffect(() => {
    if (isFetchingGuidebook) {
      setGuidebookButtonDisabled(true);
    } else {
      setGuidebookButtonDisabled(false);
    }
  }, [isFetchingGuidebook]);

  if (!isGuidebookEnabled || !propertyUid) {
    return null;
  }

  const redirectToGuidebook = async () => {
    const guidebookUrl = await getPropertyGuidebookURL({ propertyUid });
    if (guidebookUrl) {
      window.open(guidebookUrl, '_blank');
    } else {
      notifyError(t('common.guidebookAccessError'));
    }
  };

  const text = t('pageProperty.mainSettings.header.guidebook');

  return (
    <Tooltip id="guidebook-link" text={text}>
      <IconButton
        disabled={guidebookButtonDisabled}
        data-testid="guidebook-link"
        onClick={redirectToGuidebook}
      >
        <BookIconSvg width={20} height={20} />
      </IconButton>
    </Tooltip>
  );
};

GuidebookHeaderButton.defaultProps = {
  propertyUid: undefined,
};

export default GuidebookHeaderButton;
